export default __webpack_public_path__ + "3f75fe679ea44905647a979da369020d.png";